import { DataArea24Filled, DataArea24Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const ServiceApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "ServiceApp" */ "./ServiceApp");
    return { default: namedExport.ServiceApp };
});

export const Service: TeamAppConfig = {
    title: "Service Hub",
    regularIcon: DataArea24Regular,
    filledIcon: DataArea24Filled,
    path: "/service",
    description: "Service hub",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["service"],
    app: ServiceApp
};
